module.exports = __webpack_public_path__ + "static/media/34_tn.6831610e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/34_tn.jpg
// module id = 670
// module chunks = 0